import SearchSelect from './SearchSelect'

export default SearchSelect
